/**
 * Wait-time stats for /theexperience mobile-ordering deck.
 * Update these numbers after each measured event — UI copy reads from here.
 */
export const MOBILE_ORDERING_EVENT_STATS = {
  eventLabel: 'Strike After Dark',
  attendees: 150,
  lineWaitMinutes: 9,
  counterFulfillmentMinutes: 2.5,
  /** decide to order → order in hand */
  totalWaitMinutes: 11.5,
};
